/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as LoginRecoveryCodesRouteImport } from './routes/login.recovery-codes'
import { Route as LoginPasswordChangeRouteImport } from './routes/login.password-change'
import { Route as LoginMfaVerifyRouteImport } from './routes/login.mfa-verify'
import { Route as LoginMfaEnrollRouteImport } from './routes/login.mfa-enroll'
import { Route as AuthedTerminalRouteImport } from './routes/_authed.terminal'
import { Route as AuthedOpsRouteImport } from './routes/_authed.ops'
import { Route as AuthedIntelRouteImport } from './routes/_authed.intel'
import { Route as AuthedHorizonRouteImport } from './routes/_authed.horizon'
import { Route as AuthedAwardsRouteImport } from './routes/_authed.awards'
import { Route as AuthedAuditRouteImport } from './routes/_authed.audit'
import { Route as AuthedAccountRouteImport } from './routes/_authed.account'
import { Route as AuthedVendorNameRouteImport } from './routes/_authed.vendor.$name'
import { Route as AuthedTerminalClosingSoonRouteImport } from './routes/_authed.terminal.closing-soon'
import { Route as AuthedSettingsFocusRouteImport } from './routes/_authed.settings.focus'
import { Route as AuthedBriefIdRouteImport } from './routes/_authed.brief.$id'
import { Route as AuthedAgencyNameRouteImport } from './routes/_authed.agency.$name'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRoute,
} as any)
const LoginRecoveryCodesRoute = LoginRecoveryCodesRouteImport.update({
  id: '/recovery-codes',
  path: '/recovery-codes',
  getParentRoute: () => LoginRoute,
} as any)
const LoginPasswordChangeRoute = LoginPasswordChangeRouteImport.update({
  id: '/password-change',
  path: '/password-change',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaVerifyRoute = LoginMfaVerifyRouteImport.update({
  id: '/mfa-verify',
  path: '/mfa-verify',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaEnrollRoute = LoginMfaEnrollRouteImport.update({
  id: '/mfa-enroll',
  path: '/mfa-enroll',
  getParentRoute: () => LoginRoute,
} as any)
const AuthedTerminalRoute = AuthedTerminalRouteImport.update({
  id: '/terminal',
  path: '/terminal',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOpsRoute = AuthedOpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedIntelRoute = AuthedIntelRouteImport.update({
  id: '/intel',
  path: '/intel',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHorizonRoute = AuthedHorizonRouteImport.update({
  id: '/horizon',
  path: '/horizon',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAwardsRoute = AuthedAwardsRouteImport.update({
  id: '/awards',
  path: '/awards',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditRoute = AuthedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountRoute = AuthedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedVendorNameRoute = AuthedVendorNameRouteImport.update({
  id: '/vendor/$name',
  path: '/vendor/$name',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTerminalClosingSoonRoute =
  AuthedTerminalClosingSoonRouteImport.update({
    id: '/closing-soon',
    path: '/closing-soon',
    getParentRoute: () => AuthedTerminalRoute,
  } as any)
const AuthedSettingsFocusRoute = AuthedSettingsFocusRouteImport.update({
  id: '/settings/focus',
  path: '/settings/focus',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBriefIdRoute = AuthedBriefIdRouteImport.update({
  id: '/brief/$id',
  path: '/brief/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgencyNameRoute = AuthedAgencyNameRouteImport.update({
  id: '/agency/$name',
  path: '/agency/$name',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRouteWithChildren
  '/account': typeof AuthedAccountRoute
  '/audit': typeof AuthedAuditRoute
  '/awards': typeof AuthedAwardsRoute
  '/horizon': typeof AuthedHorizonRoute
  '/intel': typeof AuthedIntelRoute
  '/ops': typeof AuthedOpsRoute
  '/terminal': typeof AuthedTerminalRouteWithChildren
  '/login/mfa-enroll': typeof LoginMfaEnrollRoute
  '/login/mfa-verify': typeof LoginMfaVerifyRoute
  '/login/password-change': typeof LoginPasswordChangeRoute
  '/login/recovery-codes': typeof LoginRecoveryCodesRoute
  '/login/': typeof LoginIndexRoute
  '/agency/$name': typeof AuthedAgencyNameRoute
  '/brief/$id': typeof AuthedBriefIdRoute
  '/settings/focus': typeof AuthedSettingsFocusRoute
  '/terminal/closing-soon': typeof AuthedTerminalClosingSoonRoute
  '/vendor/$name': typeof AuthedVendorNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AuthedAccountRoute
  '/audit': typeof AuthedAuditRoute
  '/awards': typeof AuthedAwardsRoute
  '/horizon': typeof AuthedHorizonRoute
  '/intel': typeof AuthedIntelRoute
  '/ops': typeof AuthedOpsRoute
  '/terminal': typeof AuthedTerminalRouteWithChildren
  '/login/mfa-enroll': typeof LoginMfaEnrollRoute
  '/login/mfa-verify': typeof LoginMfaVerifyRoute
  '/login/password-change': typeof LoginPasswordChangeRoute
  '/login/recovery-codes': typeof LoginRecoveryCodesRoute
  '/login': typeof LoginIndexRoute
  '/agency/$name': typeof AuthedAgencyNameRoute
  '/brief/$id': typeof AuthedBriefIdRoute
  '/settings/focus': typeof AuthedSettingsFocusRoute
  '/terminal/closing-soon': typeof AuthedTerminalClosingSoonRoute
  '/vendor/$name': typeof AuthedVendorNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRouteWithChildren
  '/_authed/account': typeof AuthedAccountRoute
  '/_authed/audit': typeof AuthedAuditRoute
  '/_authed/awards': typeof AuthedAwardsRoute
  '/_authed/horizon': typeof AuthedHorizonRoute
  '/_authed/intel': typeof AuthedIntelRoute
  '/_authed/ops': typeof AuthedOpsRoute
  '/_authed/terminal': typeof AuthedTerminalRouteWithChildren
  '/login/mfa-enroll': typeof LoginMfaEnrollRoute
  '/login/mfa-verify': typeof LoginMfaVerifyRoute
  '/login/password-change': typeof LoginPasswordChangeRoute
  '/login/recovery-codes': typeof LoginRecoveryCodesRoute
  '/login/': typeof LoginIndexRoute
  '/_authed/agency/$name': typeof AuthedAgencyNameRoute
  '/_authed/brief/$id': typeof AuthedBriefIdRoute
  '/_authed/settings/focus': typeof AuthedSettingsFocusRoute
  '/_authed/terminal/closing-soon': typeof AuthedTerminalClosingSoonRoute
  '/_authed/vendor/$name': typeof AuthedVendorNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/account'
    | '/audit'
    | '/awards'
    | '/horizon'
    | '/intel'
    | '/ops'
    | '/terminal'
    | '/login/mfa-enroll'
    | '/login/mfa-verify'
    | '/login/password-change'
    | '/login/recovery-codes'
    | '/login/'
    | '/agency/$name'
    | '/brief/$id'
    | '/settings/focus'
    | '/terminal/closing-soon'
    | '/vendor/$name'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/audit'
    | '/awards'
    | '/horizon'
    | '/intel'
    | '/ops'
    | '/terminal'
    | '/login/mfa-enroll'
    | '/login/mfa-verify'
    | '/login/password-change'
    | '/login/recovery-codes'
    | '/login'
    | '/agency/$name'
    | '/brief/$id'
    | '/settings/focus'
    | '/terminal/closing-soon'
    | '/vendor/$name'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/_authed/account'
    | '/_authed/audit'
    | '/_authed/awards'
    | '/_authed/horizon'
    | '/_authed/intel'
    | '/_authed/ops'
    | '/_authed/terminal'
    | '/login/mfa-enroll'
    | '/login/mfa-verify'
    | '/login/password-change'
    | '/login/recovery-codes'
    | '/login/'
    | '/_authed/agency/$name'
    | '/_authed/brief/$id'
    | '/_authed/settings/focus'
    | '/_authed/terminal/closing-soon'
    | '/_authed/vendor/$name'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/recovery-codes': {
      id: '/login/recovery-codes'
      path: '/recovery-codes'
      fullPath: '/login/recovery-codes'
      preLoaderRoute: typeof LoginRecoveryCodesRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/password-change': {
      id: '/login/password-change'
      path: '/password-change'
      fullPath: '/login/password-change'
      preLoaderRoute: typeof LoginPasswordChangeRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-verify': {
      id: '/login/mfa-verify'
      path: '/mfa-verify'
      fullPath: '/login/mfa-verify'
      preLoaderRoute: typeof LoginMfaVerifyRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-enroll': {
      id: '/login/mfa-enroll'
      path: '/mfa-enroll'
      fullPath: '/login/mfa-enroll'
      preLoaderRoute: typeof LoginMfaEnrollRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_authed/terminal': {
      id: '/_authed/terminal'
      path: '/terminal'
      fullPath: '/terminal'
      preLoaderRoute: typeof AuthedTerminalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ops': {
      id: '/_authed/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof AuthedOpsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/intel': {
      id: '/_authed/intel'
      path: '/intel'
      fullPath: '/intel'
      preLoaderRoute: typeof AuthedIntelRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/horizon': {
      id: '/_authed/horizon'
      path: '/horizon'
      fullPath: '/horizon'
      preLoaderRoute: typeof AuthedHorizonRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/awards': {
      id: '/_authed/awards'
      path: '/awards'
      fullPath: '/awards'
      preLoaderRoute: typeof AuthedAwardsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit': {
      id: '/_authed/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthedAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account': {
      id: '/_authed/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthedAccountRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/vendor/$name': {
      id: '/_authed/vendor/$name'
      path: '/vendor/$name'
      fullPath: '/vendor/$name'
      preLoaderRoute: typeof AuthedVendorNameRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/terminal/closing-soon': {
      id: '/_authed/terminal/closing-soon'
      path: '/closing-soon'
      fullPath: '/terminal/closing-soon'
      preLoaderRoute: typeof AuthedTerminalClosingSoonRouteImport
      parentRoute: typeof AuthedTerminalRoute
    }
    '/_authed/settings/focus': {
      id: '/_authed/settings/focus'
      path: '/settings/focus'
      fullPath: '/settings/focus'
      preLoaderRoute: typeof AuthedSettingsFocusRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/brief/$id': {
      id: '/_authed/brief/$id'
      path: '/brief/$id'
      fullPath: '/brief/$id'
      preLoaderRoute: typeof AuthedBriefIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agency/$name': {
      id: '/_authed/agency/$name'
      path: '/agency/$name'
      fullPath: '/agency/$name'
      preLoaderRoute: typeof AuthedAgencyNameRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedTerminalRouteChildren {
  AuthedTerminalClosingSoonRoute: typeof AuthedTerminalClosingSoonRoute
}

const AuthedTerminalRouteChildren: AuthedTerminalRouteChildren = {
  AuthedTerminalClosingSoonRoute: AuthedTerminalClosingSoonRoute,
}

const AuthedTerminalRouteWithChildren = AuthedTerminalRoute._addFileChildren(
  AuthedTerminalRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAccountRoute: typeof AuthedAccountRoute
  AuthedAuditRoute: typeof AuthedAuditRoute
  AuthedAwardsRoute: typeof AuthedAwardsRoute
  AuthedHorizonRoute: typeof AuthedHorizonRoute
  AuthedIntelRoute: typeof AuthedIntelRoute
  AuthedOpsRoute: typeof AuthedOpsRoute
  AuthedTerminalRoute: typeof AuthedTerminalRouteWithChildren
  AuthedAgencyNameRoute: typeof AuthedAgencyNameRoute
  AuthedBriefIdRoute: typeof AuthedBriefIdRoute
  AuthedSettingsFocusRoute: typeof AuthedSettingsFocusRoute
  AuthedVendorNameRoute: typeof AuthedVendorNameRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAccountRoute: AuthedAccountRoute,
  AuthedAuditRoute: AuthedAuditRoute,
  AuthedAwardsRoute: AuthedAwardsRoute,
  AuthedHorizonRoute: AuthedHorizonRoute,
  AuthedIntelRoute: AuthedIntelRoute,
  AuthedOpsRoute: AuthedOpsRoute,
  AuthedTerminalRoute: AuthedTerminalRouteWithChildren,
  AuthedAgencyNameRoute: AuthedAgencyNameRoute,
  AuthedBriefIdRoute: AuthedBriefIdRoute,
  AuthedSettingsFocusRoute: AuthedSettingsFocusRoute,
  AuthedVendorNameRoute: AuthedVendorNameRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface LoginRouteChildren {
  LoginMfaEnrollRoute: typeof LoginMfaEnrollRoute
  LoginMfaVerifyRoute: typeof LoginMfaVerifyRoute
  LoginPasswordChangeRoute: typeof LoginPasswordChangeRoute
  LoginRecoveryCodesRoute: typeof LoginRecoveryCodesRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginMfaEnrollRoute: LoginMfaEnrollRoute,
  LoginMfaVerifyRoute: LoginMfaVerifyRoute,
  LoginPasswordChangeRoute: LoginPasswordChangeRoute,
  LoginRecoveryCodesRoute: LoginRecoveryCodesRoute,
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
